import { Box, Button, TextField } from "@mui/material";
import { useState } from "react";
import Page from "../components/Page";

export default function Settings() {
  const initialBaseURL = localStorage.getItem("baseURL");
  const initialUser = localStorage.getItem("user");
  const initialPassword = localStorage.getItem("password");

  const [baseURL, setBaseURL] = useState(initialBaseURL || "");
  const [user, setUser] = useState(initialUser || "");
  const [password, setPassword] = useState(initialPassword || "");

  return (
    <Page title="Settings">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Base URL"
          value={baseURL}
          onChange={(e) => setBaseURL(e.target.value)}
        />
        <TextField
          label="User"
          value={user}
          onChange={(e) => setUser(e.target.value)}
        />
        <TextField
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            localStorage.setItem("baseURL", baseURL);
            localStorage.setItem("user", user);
            localStorage.setItem("password", password);
            alert("Settings saved");
          }}
        >
          Save
        </Button>
      </Box>
    </Page>
  );
}
